<fuse-widget  class="widget p-0 h-100-p" fxLayout="column" fxLayoutAlign="space-between center">

    <!-- Front -->
    <div class="fuse-widget-front mat-white-bg mat-elevation-z2">
        
      <mat-toolbar class="px-16 py-12 border-bottom mat-accent-bg title-bar" fxLayout="row" fxLayoutAlign="space-between center">
          <div fxLayout="row" fxLayoutAlign="start center">
              <div class="h3 title pr-4">Users</div>
          </div>
      </mat-toolbar>

      <div fxLayout="column" fxLayoutAlign="start start" class="px-16 py-16 users">
        <app-check-list class="py-8 w-100-p aggregatelist" [list]="userAggregateCheckList" [multiselect]="false" (onChanged)="userAggregateChanged($event)"></app-check-list>
        <mat-divider class="px-16 w-100-p"></mat-divider>
        <app-check-list class="py-8 w-100-p" [list]="userCheckList" [multiselect]="true" (onChanged)="usersChanged($event)"></app-check-list>
      </div>

    </div>
    <!-- / Front -->

</fuse-widget>